import { render } from "./RightDrawer.vue?vue&type=template&id=68e274a7&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"

import "./RightDrawer.vue?vue&type=style&index=0&id=68e274a7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e274a7"]])

export default __exports__